import React from "react";
import { Container, ButtonsContainer, StyledColorButton, Typography } from "./account-selector.styled";
import { accountTypes } from "@/constants";

export default function AccountSelector({ selectedAccountTypeId, setSelectedAccountTypeId }) {
    const isEmployeeSelected = selectedAccountTypeId === accountTypes.employee;
    const isCompanySelected = selectedAccountTypeId === accountTypes.company;

    return (
        <Container>
            <ButtonsContainer>
                <StyledColorButton
                    onClick={() => setSelectedAccountTypeId(accountTypes.employee)}
                    backgroundcolor={isEmployeeSelected ? "white" : "#e07454"}
                    textcolor={isEmployeeSelected ? "#6ec4e8" : "white"}
                    height={isEmployeeSelected ? 48 : 36}
                >
                    <Typography>Nómina</Typography>
                </StyledColorButton>
                <StyledColorButton
                    onClick={() => setSelectedAccountTypeId(accountTypes.company)}
                    backgroundcolor={isCompanySelected ? "white" : "#47a3c3"}
                    textcolor={isCompanySelected ? "#6ec4e8" : "#ff8d6a"}
                    height={isCompanySelected ? 48 : 36}
                >
                    <Typography>Cuenta Empresa</Typography>
                </StyledColorButton>
            </ButtonsContainer>
        </Container>
    );
};